<template>
  <ul v-if="model" class="filter-list">
    <li
      class="filter-item"
      role="none"
      v-for="(item, index) in sorted"
      :key="index"
    >
      <CheckBox
        :id="item.Name.replace(' ', '')"
        :medium="true"
        :isChecked="filters[index]"
        :disabled="item.count === 0"
        :label="item.outputName"
        @change="(e) => filterChanged(e, index)"
      />
    </li>
  </ul>
</template>
<script>

import CheckBox from '@/Scripts/components/shared/CheckBox/CheckBox.vue';

export default {
  name: 'FilterList',
  components: {
    CheckBox
  },
  data () {
    return {
      filters: []
    };
  },
  props: {
    model: Array,
    max: {
      type: Number,
      default: 3
    }
  },
  computed: {
    sorted () {
      const list = [...this.model];
      list.forEach(item => {
        item.outputName = `${this.getName(item)} (${item.count})`;
      });
      return list.sort((a, b) => {
        if (a.outputName < b.outputName) { return -1; }
        if (a.outputName > b.outputName) { return 1; }
        return 0;
      });
    }
  },
  methods: {
    getName (item) {
      const str = this.insertString('ProductPage', 'Ratings', item.Name);
      if (typeof str !== 'undefined') {
        return str;
      }
      return item.Name;
    },
    filterChanged (e, index) {
      this.$set(this.filters, index, e);
      const list = [];
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filters[i]) {
          list.push(this.sorted[i].Name);
        }
      }
      this.$emit('filterHasChanged', list);
    }

  }
};
</script>
